import React, { Component } from 'react';
import {Subtopic,TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const indonesia = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 8 ,0]
    },{
        name: 'Some decline',
        data: [0, 3, 8]
    },{
        name: 'No change',
        data: [0, 3, 0]
    },{
        name: 'Some growth',
        data: [42, 45, 25]
    },{
        name: 'Significant growth',
        data: [58, 42, 67]
    }]
}

const indonesia2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 6 ,4]
    },{
        name: 'Some decline',
        data: [0, 3, 4]
    },{
        name: 'No change',
        data: [0, 14, 4]
    },{
        name: 'Some growth',
        data: [50, 51, 22]
    },{
        name: 'Significant growth',
        data: [50, 26, 65]
    }]
}


const vietnam = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 3 ,0]
    },{
        name: 'Some decline',
        data: [0, 0, 5]
    },{
        name: 'No change',
        data: [0, 10, 6]
    },{
        name: 'Some growth',
        data: [73, 42, 47]
    },{
        name: 'Significant growth',
        data: [27, 45, 42]
    }]
}

const vietnam2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 3 , 0]
    },{
        name: 'Some decline',
        data: [0, 0, 11]
    },{
        name: 'No change',
        data: [0, 16, 5]
    },{
        name: 'Some growth',
        data: [73, 47, 56]
    },{
        name: 'Significant growth',
        data: [27, 34, 28]
    }]
}


const singapore = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [8, 0 ,0]
    },{
        name: 'Some decline',
        data: [8, 2, 0]
    },{
        name: 'No change',
        data: [8, 12, 16]
    },{
        name: 'Some growth',
        data: [62, 51, 52]
    },{
        name: 'Significant growth',
        data: [15, 34, 32]
    }]
}

const singapore2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [8, 2, 0]
    },{
        name: 'Some decline',
        data: [8, 5, 4]
    },{
        name: 'No change',
        data: [8, 10, 17]
    },{
        name: 'Some growth',
        data: [54, 54, 42]
    },{
        name: 'Significant growth',
        data: [23, 29, 38]
    }]
}

const thailand = {
  chart: {
        type: 'bar'
    },
    title: {
        text: 'How do you see the number of startups in THAILAND changing over the next 1-2 years?'
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 3, 0]
    },{
        name: 'Some decline',
        data: [9, 7, 0]
    },{
        name: 'No change',
        data: [0, 11, 5]
    },{
        name: 'Some growth',
        data: [27, 62, 67]
    },{
        name: 'Significant growth',
        data: [64, 17, 28]
    }]
}

const thailand2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: 'How do you see the amount of VC funding in THAILAND changing over the next 1-2 years?'
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 4, 0]
    },{
        name: 'Some decline',
        data: [0, 7, 6]
    },{
        name: 'No change',
        data: [0, 14, 0]
    },{
        name: 'Some growth',
        data: [45, 61, 77]
    },{
        name: 'Significant growth',
        data: [55, 14, 17]
    }]
}

const malaysia = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 0 ,0]
    },{
        name: 'Some decline',
        data: [0, 5, 0]
    },{
        name: 'No change',
        data: [17, 13, 20]
    },{
        name: 'Some growth',
        data: [67, 63, 55]
    },{
        name: 'Significant growth',
        data: [17, 18, 25]
    }]
}

const malaysia2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 3, 0]
    },{
        name: 'Some decline',
        data: [9, 10, 0]
    },{
        name: 'No change',
        data: [27, 20, 26]
    },{
        name: 'Some growth',
        data: [45, 55, 53]
    },{
        name: 'Significant growth',
        data: [18, 13, 21]
    }]
}


const philippines = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 3 ,0]
    },{
        name: 'Some decline',
        data: [0, 0, 11]
    },{
        name: 'No change',
        data: [18, 28, 22]
    },{
        name: 'Some growth',
        data: [45, 47, 56]
    },{
        name: 'Significant growth',
        data: [36, 22, 11]
    }]
}

const philippines2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significant decline',
        data: [0, 3, 0]
    },{
        name: 'Some decline',
        data: [0, 3, 6]
    },{
        name: 'No change',
        data: [27, 39, 31]
    },{
        name: 'Some growth',
        data: [45, 44, 44]
    },{
        name: 'Significant growth',
        data: [27, 11, 19]
    }]
}





export class ChapterTwentyFour extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

        <TextHolder text="Survey respondents were optimistic for the SEA tech startup ecosystem, expressing confidence in its growth over the next 12 to 24 months. There were, however, different opinions on the speed of growth of each of the six economies covered in this report." />

        <TextHolder text="VCs and investors believed there would be “significant growth” opportunities in Indonesia, while founders were most bullish on Vietnam. Community builders went against the grain, overwhelmingly rooting for Thailand. The following charts reflect their views on growth for the different countries." />

        <TextHolder text="On the potential for growth in different countries, A. Balasubramaniam, head of funding ecosystem at MDEC, said:" />
        <TextHolder text="“The regions where there is most potential for growth in the tech industry in SEA are Indonesia, Vietnam, Singapore, and Malaysia. The industries that show the most potential for growth are banking, financial services, and insurance—namely fintech, e-commerce, and IoT.”" />
        <TextHolder text="" />



          <Highchartscomponent chartsTitle="Forecasted growth: INDONESIA" chartsText="How do you see the number of startups in INDONESIA changing over the next 1-2 years?" options={indonesia} source="Source: 2018 State of SE Asian Tech Survey" />


          <Highchartscomponent options={indonesia2} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the amount of VC funding in INDONESIA changing over the next 1-2 years?"/>

          <Highchartscomponent  chartsTitle="Forecasted growth: VIETNAM" options={vietnam} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the number of startups in VIETNAM changing over the next 1-2 years?"/>
          <Highchartscomponent options={vietnam2} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the amount of VC funding in VIETNAM changing over the next 1-2 years?"/>

          <Highchartscomponent  chartsTitle="Forecasted growth: SINGAPORE" options={singapore} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the number of startups in SINGAPORE changing over the next 1-2 years?"/>
          <Highchartscomponent  options={singapore2} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the amount of VC funding in SINGAPORE changing over the next 1-2 years?"/>

          <Highchartscomponent chartsTitle="Forecasted growth: THAILAND" options={thailand} source="Source: 2018 State of SE Asian Tech Survey" />
          <Highchartscomponent options={thailand2} source="Source: 2018 State of SE Asian Tech Survey" />

          <Highchartscomponent chartsTitle="Forecasted growth: MALAYSIA" options={malaysia} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the number of startups in MALAYSIA changing over the next 1-2 years?"/>
          <Highchartscomponent options={malaysia2} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the amount of VC funding in MALAYSIA changing over the next 1-2 years?"/>

          <Highchartscomponent chartsTitle="Forecasted growth: PHILIPPINES" options={philippines} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the number of startups in PHILIPPINES changing over the next 1-2 years?"/>
          <Highchartscomponent options={philippines2} source="Source: 2018 State of SE Asian Tech Survey" chartsText="How do you see the amount of VC funding in PHILIPPINES changing over the next 1-2 years?"/>

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/24.js